import React, { useState } from "react";
import "./TermsAndConditions.css";

interface TermsAndConditionsProps {
    isAccepted: boolean;
    onAcceptChange: (accepted: boolean) => void;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
    isAccepted,
    onAcceptChange,
}) => {
    const [showDialog, setShowDialog] = useState(false);

    const handleTermsClick = (e: React.MouseEvent) => {
        e.preventDefault();
        setShowDialog(true);
    };

    const closeDialog = () => {
        setShowDialog(false);
    };

    return (
        <>
            <div className="terms-container">
                <label className="terms-checkbox" htmlFor="terms-checkbox">
                    <input
                        id="terms-checkbox"
                        type="checkbox"
                        checked={isAccepted}
                        onChange={(e) => onAcceptChange(e.target.checked)}
                    />
                    <span className="checkmark" />
                    I agree to the
                    <button
                        type="button"
                        className="terms-link"
                        onClick={handleTermsClick}
                    >
                        Terms and Conditions
                    </button>
                </label>
            </div>

            {showDialog && (
                <div className="terms-dialog-overlay" onClick={closeDialog}>
                    <div className="terms-dialog" onClick={(e) => e.stopPropagation()}>
                        <div className="terms-dialog-header">
                            <h2>ARTE Internal Development Opt-In Allowance Terms and Conditions</h2>
                            <button
                                type="button"
                                className="terms-dialog-close"
                                onClick={closeDialog}
                                aria-label="Close"
                            >
                                ×
                            </button>
                        </div>
                        <div className="terms-dialog-content">
                            <p>
                                As a contributing member of the extended ARTE team that need access to
                                OfficePLUS AIGC Workflow Portal and other supporting user interface and
                                service experiences, I hereby to attest that:
                            </p>
                            <ul>
                                <li>
                                    I am a Microsoft employee or contractor and have signed all necessary
                                    NDA and other disclosures.
                                </li>
                                <li>
                                    I am fully aware and accept that the OfficePLUS AIGC Workflow Portal
                                    user interfaces and services I may be exposed to are pre-release,
                                    in-development, and may not have completed full privacy / security /
                                    compliance reviews yet.
                                </li>
                                <li>
                                    Employee data collection and use is covered by the Data Privacy Notice (
                                    <a
                                        href="https://privacy.microsoft.com/en-US/data-privacy-notice"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        https://privacy.microsoft.com/en-US/data-privacy-notice
                                    </a>
                                    ).
                                </li>
                                <li>
                                    I understand my access to OfficePLUS AIGC Workflow Portal and
                                    supporting user interface and service experiences is
                                    {" "}
                                    <strong>exclusively for internal development purposes only</strong>
                                    . All rights of the prompts I input in, and contents generated from
                                    OfficePLUS AIGC Workflow Portal for such purpose belong to Microsoft.
                                </li>
                                <li>
                                    By accepting these additional terms and conditions I am opting into
                                    these experiences including the collection and storage of telemetry
                                    and other usage metrics. I understand that I am not required to opt
                                    into these experiences and do so voluntarily and willingly.
                                    To opt out of the experiences I may leave this group at any time.
                                </li>
                            </ul>
                        </div>
                        <div className="terms-dialog-footer">
                            <button
                                type="button"
                                onClick={closeDialog}
                                className="terms-dialog-button"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TermsAndConditions;
